export default "__VITE_ASSET__3ffd1b7e__"